// ============================================================
// خدمة API لنظام تسوية العُهد
// Custody Settlement System API Service
// ============================================================

import axios from './axiosInstance';
import {
  CustodyExpenseCategory,
  CreateCustodyExpenseCategory,
  UpdateCustodyExpenseCategory,
  CustodySettlement,
  CreateCustodySettlement,
  UpdateCustodySettlement,
} from '../types/custodySettlements.types';

// ============================================================
// فئات مصاريف العُهد — الكونفجراشن
// ============================================================

export const expenseCategoryService = {
  // جلب جميع الفئات
  getAll: () =>
    axios.get<CustodyExpenseCategory[]>('/CustodyExpenseCategories'),

  // جلب الفئات النشطة فقط
  getActive: () =>
    axios.get<CustodyExpenseCategory[]>('/CustodyExpenseCategories/active'),

  // جلب فئة بالمعرّف
  getById: (id: number) =>
    axios.get<CustodyExpenseCategory>(`/CustodyExpenseCategories/${id}`),

  // إنشاء فئة جديدة
  create: (data: CreateCustodyExpenseCategory) =>
    axios.post<CustodyExpenseCategory>('/CustodyExpenseCategories', data),

  // تحديث فئة
  update: (id: number, data: UpdateCustodyExpenseCategory) =>
    axios.put<CustodyExpenseCategory>(`/CustodyExpenseCategories/${id}`, data),

  // حذف فئة
  delete: (id: number) =>
    axios.delete(`/CustodyExpenseCategories/${id}`),
};

// ============================================================
// كشوف تسوية العُهد
// ============================================================

export const custodySettlementService = {
  // جلب جميع الكشوف مع فلاتر اختيارية
  getAll: (params?: {
    custodyId?: number;
    status?: string;
    fromDate?: string;
    toDate?: string;
  }) => axios.get<CustodySettlement[]>('/CustodySettlements', { params }),

  // جلب كشف بالمعرّف مع التفاصيل
  getById: (id: number) =>
    axios.get<CustodySettlement>(`/CustodySettlements/${id}`),

  // إنشاء كشف تسوية جديد
  create: (data: CreateCustodySettlement) =>
    axios.post<CustodySettlement>('/CustodySettlements', data),

  // تحديث كشف تسوية — Draft فقط
  update: (id: number, data: UpdateCustodySettlement) =>
    axios.put<CustodySettlement>(`/CustodySettlements/${id}`, data),

  // اعتماد كشف التسوية — ينشئ القيد المحاسبي
  approve: (id: number) =>
    axios.post<CustodySettlement>(`/CustodySettlements/${id}/approve`),

  // إلغاء الاعتماد
  unapprove: (id: number) =>
    axios.post<CustodySettlement>(`/CustodySettlements/${id}/unapprove`),

  // حذف كشف تسوية — Draft فقط
  delete: (id: number) =>
    axios.delete(`/CustodySettlements/${id}`),

  // توليد رقم كشف تلقائي
  generateNumber: () =>
    axios.get<string>('/CustodySettlements/generate-number'),
};